export default __webpack_public_path__ + "static/media/Girdle of the Black Pharaoh.e0299382.jpg";